import type { FaireProductEntity } from "../../entity_types/product";

export const p_sdbskqppw9: FaireProductEntity = {
  token: "p_sdbskqppw9",
  type: "product",
  name: "2.5 Inch Golden Healer Quartz Cluster from Arkansas #2",
  brandToken: "b_wmrj23yq37",
  brandName: "Wildheart Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/b6330ad1ca8df30dfa4697fb657fb1e391ac221c952addb90d97deaa6b2be717.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7adc40387b364cc82be6e09de990f408e45c7b6113955a892a3b6ac4b37a9d2e.jpeg",
    "https://cdn.faire.com/fastly/2c1c4008412b4a1fca30c3e2937ce6f6ff99616ab270d8a9aa51e6023824cef9.jpeg",
    "https://cdn.faire.com/fastly/60e94d099f14553110e8a79e543aa39b3078cfc6a861dd944b4130e9403c2eae.jpeg",
    "https://cdn.faire.com/fastly/7ac90a7a73213adc5a3fd77f095a3399c03026f44ecc5ff837d38e49f99ec71e.jpeg",
    "https://cdn.faire.com/fastly/96bce2a569054d2fcc1a76862fae117ce66950a3a2ff52dbf29764fccea6d7fc.jpeg",
    "https://cdn.faire.com/fastly/5698be03ea89a9a2f06cedb0e29e0bf0b1c3f04e738616beaaece8c988de2285.jpeg",
    "https://cdn.faire.com/fastly/cc921e3effbed7433ab80901b2601efac3c09546b750059bf44cf695d21c859a.jpeg",
    "https://cdn.faire.com/fastly/b38ee2796afb2d84d102af2adf31d5b3bb143b0463525dc988f525f54da8ce50.jpeg",
    "https://cdn.faire.com/fastly/70fbc12771eaf0a03201a27d2ff719d7d489dd29b7dd0e1a05061ad1454725db.jpeg",
  ],
  priceDollars: 48.5,
  description:
    "The Golden Healer is a powerful healing crystal as it allows the golden light of Universal Life Force to flow into the body through the Crown Chakra.  The energy then spreads its golden light throughout the body as it clears blockages and imbalances that ready the body for multi-level healing.\n\nThe Golden Ray energy of the Golden Healer may represent the Divine Spirit, Source and Creation.  A Master Healer, the Golden Healer is of the highest vibration.  Its energy is powerful, yet gentle and soothing.\n\nGolden Healers can be used to raise the holder’s energy vibration or frequency, which will facilitate spiritual communications over a long distance, including between worlds and dimensions.",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:22.593Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
